import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';
import { OrdersService } from '@app/services/order/orders.service';
declare var window: any;

@Component({
    selector: 'legal-notice',
    templateUrl: 'legal-notice.component.html',
    styleUrls: ['legal-notice.component.scss']
})
export class LegalNoticeComponent {

    restaurant: "";
    website: "";
    address: "";
    phone: "";
    email: "";
    subscriptions: Subscription[] = [];
    ourApp = false;
    constructor(private pdvService: PdvService, private orderService: OrdersService,
        @Inject(PLATFORM_ID) private platformId: Object,) {
        const sub = this.pdvService.pdv.subscribe(pdv => {
            this.address = pdv.address;
            this.restaurant = pdv.name;
            this.phone = pdv.phone;
            this.email = pdv.emailContact;
            if (isPlatformBrowser(this.platformId)) {
                this.website = window.location.hostname;
            }
        });
        this.orderService.ourAppEvent.subscribe(
            data => {
                this.ourApp = data;
            }
        )
        this.subscriptions.push(sub);
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
}
